const ar = {
  translation: {
    selectLanguage: "اللغة",
    saveButton: "حفظ",
    footerText:
      "أوردرات تقدم مزيجًا من الابتكار والتكنولوجيا لتسهيل حياة الأنشطة التجارية والمجتمع بحلول سلسة وفعالة.",
    footerLinkHome: "الرئيسية",
    footerLinkPP: "سياسة الخصوصية",
    footerLinkTC: "الشروط والأحكام",
    footerEndText: "© 2025 اوردرات - جميع الحقوق محفوظة",
    followUs: "تابعنا على",
    poweredBy: "بدعم من",
    linksTitle: "روابط مفيدة",
    subTotal: "الإجمالي الفرعي",
    deliveryFee: "رسوم التوصيل",
    MinimumDeliveryFee: "الحد الأدنى لرسوم التوصيل",
    haveVoucher: "هل لديك قسيمة؟",
    remove: "إزالة",
    change: "تغيير",
    tip: "الإكرامية",
    taxFee: "الضريبه",
    total: "الإجمالي",
    discount: "خصم",
    name: "الاسم",
    phone: "رقم الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    changeAddress: "تغيير العنوان",
    contactInfo: "معلومات التواصل",
    paymentMethod: "طريقة الدفع",
    orderBtn: "تأكيد الطلب",
    deliveryTime: "وقت التوصيل",
    delivery: "التوصيل",
    searchRestaurantPlaceholder: "ابحث عن المطاعم والأطباق",
    allRestaurant: "كل المطاعم",
    pending: "قيد الانتظار",
    accepted: "تم القبول",
    assigned: "تم تحديد مندوب",
    picked: "الاوردر مع الندوب",
    delivered: "تم التوصيل",
    completed: "تم",
    titleOrders: "طلباتي",
    titleProfile: "حسابي",
    titleSettings: "الإعدادات",
    titleHelp: "المساعدة",
    titleChat: "المحادثة",
    titleLogout: "تسجيل الخروج",
    passwordInfo: "معلومات كلمة المرور",
    myAddresses: "عناويني",
    edit: "تعديل",
    creditDebitCard: "بطاقة الائتمان/الخصم",
    paypal: "باي بال",
    cash: "الدفع نقداً",
    deliverTo: "التوصيل إلى",
    ASSIGNED: "تم تحديد مندوب",
    PENDING: "قيد الانتظار",
    PICKED: "الاوردر مع الندوب",
    ACCEPTED: "تم القبول",
    DELIVERED: "تم التوصيل",
    COMPLETED: "تم",
    orderPlaced: "تم تقديم الطلب",
    "Order ID": "رقم الأمر",
    "Order status: PENDING": "حالة الطلب: في انتظار",
    "Order status: ACCEPTED": "حالة الطلب: مقبول",
    "Order status: ASSIGNED": "حالة الطلب: مُعيَّن",
    "Order status: PICKED": "حالة الطلب: تم ​​اختياره",
    "Order status: DELIVERED": "حالة الطلب: تم ​​التسليم",
    "Order status: Order Placed": "حالة الطلب: تم ​​تقديم الطلب",
    deliveryAddress: "عنوان التوصيل",
    orderDetail: "تفاصيل الطلب",
    orderFrom: "الطلب من",
    orderNo: "رقم الطلب",
    findRestaurants: "استكشف المطاعم",
    putUsInYourPocket: "حمل تطبيقنا لتبقى على اتصال دائم.",
    containerText:
      "كل شيء بين يديك - المطاعم التي تحبها. ابحث عن الطعام الذي يناسب ذوقك واجعل اللقمة الأولى تدوم. قم بتنزيل التطبيق الآن.",
    findingAddress: "تحديد الموقع باستخدام GPS",
    zonesFunctionality: "إدارة المناطق للمطاعم والسائقين",
    multipleRestaurants: "إمكانية إضافة مطاعم متعددة",
    realTimeOrder: "متابعة فورية للطلبات.",
    differentSections: "أقسام مخصصة للترويج للمطاعم",
    previousOrder: "سجل الطلبات السابقة والمطاعم المفضلة",
    ourDelivery: "نظام التوصيل مصمم لتلبية متطلبات المستقبل",
    builtOnCommunity: "أساسها المبادئ المجتمعية",
    yourCart: "سلة التسوق",
    startAdding: "ابدأ بإضافة طلباتك إلى سلتك",
    goToCheckout: "الانتقال إلى الدفع",
    activeOrders: "الطلبات الحالية",
    pastOrders: "الطلبات السابقة",
    deliveringTo: "التوصيل إلى",
    restaurantDeliver: "نحن نتواصل مع المطعم لمعرفة وقت التوصيل المتوقع",
    riderDeliver: "نحن نتواصل مع السائق لمعرفة وقت التوصيل المتوقع",
    orderPending: "طلبك ما زال قيد الانتظار",
    areYouSure: "هل أنت متأكد؟",
    clearCartText: "تغيير المطعم سيؤدي إلى مسح الطلبات من السلة.",
    ok: "حسنًا",
    cancel: "إلغاء",
    submit: "إرسال",
    titleFavourite: "المفضلة",
    titleEmptyFav: "لا توجد مفضلات حتى الآن",
    emptyFavDesc: "كل ما تحفظه كمفضل ستجده هنا لتسهيل الطلب.",
    emptyFavBtn: "ابحث عن مفضلاتك",
    exactLocation: "هل هذا موقعك الدقيق؟",
    yourArea: "أدخل منطقتك",
    currentLocation: "استخدام الموقع الحالي",
    deliveryDetails: "تفاصيل التوصيل - مثل الطابق/المبنى",
    deliveryDetailError: "تفاصيل التوصيل مطلوبة",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    deliver: "التوصيل",
    time: "الوقت",
    pickup: "الاستلام",
    selectTime: "اختر الوقت",
    am: "صباحًا",
    pm: "مساءً",
    set: "تعيين",
    apply: "تطبيق",
    applyAVoucher: "استخدام قسيمة",
    readAll: "عرض الكل",
    readMore: "اقرأ المزيد",
    demo: "عرض توضيحي",
    getQuote: "احصل على عرض سعر",
    restaurantCloseText:
      "المطعم مغلق حاليًا. يمكنك استكشاف المطاعم الأخرى المفتوحة أو الاطلاع على القائمة للتخطيط لطلبك القادم.",
    seeOtherRestaurants: "عرض مطاعم أخرى",
    goToMenu: "الذهاب إلى القائمة",
    deliveryHours: "ساعات التوصيل",
    about: "عن التطبيق",
    reviews: "التقييمات",
    closedAllDay: "مغلق طوال اليوم",
    minute: "دقيقة",
    welcome: "مرحبًا!",
    signUpOrLogin: "سجل دخولك أو قم بالتسجيل للمتابعة",
    signInWithGoogle: "الدخول باستخدام Google",
    or: "أو",
    continueWithEmail: "المتابعة باستخدام البريد الإلكتروني",
    continueWithPhone: "المتابعة باستخدام رقم التليفون",
    terms: "الشروط والأحكام",
    privacyPolicy: "سياسة الخصوصية",
    bySigningUp: "عند التسجيل، أنت توافق على ",
    and: " و ",
    whatsYourEmail: "ما هو بريدك الإلكتروني؟",
    checkAccount: "سنتحقق مما إذا كان لديك حساب",
    continue: "متابعة",
    invalidEmail: "بريد إلكتروني غير صالح",
    letsGetStarted: "لنبدأ الآن!",
    createAccount: "أنشئ حسابك في اوردادات",
    firstnameErr1: "الاسم الأول مطلوب!",
    firstnameErr2: "الاسم الأول غير صالح!",
    lastnameErr1: "اسم العائلة مطلوب!",
    lastnameErr2: "اسم العائلة غير صالح!",
    mobileErr1: "رقم الهاتف مطلوب!",
    mobileErr2: "رقم الهاتف غير صالح!",
    emailErr2: "بريد إلكتروني غير صالح",
    passwordErr1:
      "كلمة المرور غير صالحة. يجب أن تحتوي على حرف كبير، وحرف صغير، ورقم.",
    passwordErr2: "كلمة مرور غير صالحة",
    generalErr: "هناك شيء ناقص",
    verifyEmail: "تحقق من بريدك الإلكتروني",
    enterOtp: "الرجاء إدخال رمز OTP الذي أرسلناه إلى بريدك الإلكتروني المحدث",
    enterOtpPhone: "الرجاء إدخال رمز OTP الذي أرسلناه إلى رقم هاتفك الإلكتروني",
    invalidCode: "الرمز غير صالح، الرجاء التحقق وإدخاله مرة أخرى",
    resendCode: "إعادة إرسال الرمز",
    retryAfter: "إعادة المحاولة بعد",
    loginBtn: "تسجيل الدخول",
    addToCart: "أضف إلى سلتك",
    customize: "اختار تفاصيل طلبك",
    optional: "اختياري",
    required: "مطلوب",
    specialInstructions: "تعليمات إضافية",
    anySpecific: "هل لديك تفضيلات معينة؟ أخبر المطعم.",
    selectVariation: "حدد نوع الطلب",
    closed: "مغلق",
    new: "جديد",
    orderCancelled: "تم إلغاء طلبك",
    orderCompleted: "تم إكمال الطلب بنجاح. شكرًا لك على طلبك",
    reorder: "إعادة الطلب",
    review: "مراجعة",
    subTitle: " اختر ١",
    placeholder: "على سبيل المثال، بدون مايونيز",
    phoneNumMissing: "الرقم الهاتفي مفقود",
    updatePhone: "قم بتحديث هاتفك",
    number: "الرقم؟",
    secureAcc: "نحتاج هذا لتأمين حسابك",
    verifyPhone: "تحقق من هاتفك",
    skipNow: "تخطى الآن",
    favouriteListUpdated: "تم تحديث قائمة المفضلات",
    pendingText: "في انتظار الرد من",
    acceptedText: "الوقت المقدر للتحضير",
    orderLateText: "آسف! طلبك متأخر قليلاً.",
    riderPickText: "سيقوم سائقك بالحصول عليه عندما يكون جاهزًا.",
    orderIs: "طلبك هو",
    orderAssigned: "تم تحديد الكابتن",
    orderAssignedToRider: "تم تحدي الكابتن",
    riderOnWay: "سائقك في الطريق.",
    orderHasBeen: "تم طلبك",
    enjoyYourMeal: "استمتع بوجبتك!",
    cancelled: "تم الإلغاء",
    personalDetail: "التفاصيل الشخصية",
    voucherCode: "رمز القسيمة",
    pickUp: "استلام",
    warning: "تحذير",
    warningText: "أحد العناصر غير متاح",
    cash_only: "الدفع عند التوصيل",
    business_name: "اسم الشركة",
    business_address: "عنوان الشركة",
    tell_us_business: "كلمنا عن عملك",
    created_business: "تم إنشاء الشركة!",
    label: "المنطقة",
    delivery_details: "معلومات التوصيل",
    welcome_to_orderat: "مرحبًا بك في أوردات!",
    "Order from one of our restaurants": "اطلب من أحد مطاعمنا",
    "Be our delivery team": "مستقبل التوصيل الذكي – اسهل - اسرع و اقرب.",
    "Become our partner": "كن شريكنا",
    aboutus: "رؤيتنا",
    about_us_description:
      "أوردرات هي منصة توصيل متقدمة تربط بين الشركات والعملاء وفنيي التوصيل في تجربة سلسة. سواء كنت تتطلع إلى توسيع نطاق عملك أو كسب دخل إضافي كقائد توصيل أو طلب المنتجات بسهولة - فنحن هنا لخدمتك.",
    for_companies_title: "للشركات",
    for_companies_description: "وسع نطاق عملك مع حلول توصيل سريعة وموثوقة",
    btn_text_partner: "انضم كشريك",
    for_riders: "للسائقين",
    for_riders_description:
      "انضم إلى أوردات وابدأ في تحقيق دخل مرن من التوصيل.",
    btn_text_rider: "انضم كسائق",
    for_customers: "للعملاء",
    for_customers_description: "استمتع بتجربة طلب سهلة وسريعة",
    btn_text_customer: "أطلب الآن",
    facing_problem: "هل تواجه مشكلة؟",
    contactus: "قم بالتواصل معنا",
    contact_email: "يرجى الاتصال بنا على البريد الإلكتروني الخاص بنا",
    home: "الرئيسية",
    address_selected: "تم اختيار العنوان",
    search: "بحث",
    city: "المدينة",
    register_successful: "تم التسجيل بنجاح!",
    register_as_rider: "تسجيل الكباتن!",
    your_restaurant: "مطعمك",
    add_your_restaurant: "سجل مطعمك",
    deliver_with_orderat: "قم بالتوصيل مع اوردرات",
    signup_to_deliver: "سجل لتقم بالتوصيل",
    user_registered: "تم التسجيل بنجاح!",
    cities_serving: "مدن نخدمها",
    select: "أختر",
    select_area: "قم باختيار المنطقة",
    no_areas: "لا يوجد مناطق بعد نعمل بها",
    select_option: "حدد الخيار",
    login_using_phone: "تسجيل الدخول باستخدام هاتفك",
    type_your_password: "اكتب كلمة المرور الخاصة بك",
    forgot_password: "نسيت كلمة السر؟",
    continue: "استمر",
    whatsYourPhone: "ما هو رقم تليفونك؟",
    phone_password_not_match: "خطأ في كلمة المرور",
    message_sent_successfully: "تم إرسال الرسالة بنجاح!",
  },
};
export default ar;
